/* rivexa-creatine.js — buy form, cart sync, gallery, swipe dots, header drawer. Runs once. */
(function () {
  if (window.__rvxCreatineInit) return;
  window.__rvxCreatineInit = true;

  var ROOT = document;
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  var ownAdd = false;

  /* ---------- cart drawer sync ----------
     The theme renders the drawer's contents once, at page load. Anything added
     after that — by our form or by a bundle / subscription app — leaves the
     drawer showing stale markup unless we ask Shopify for fresh section HTML
     and swap it in. That is what everything in this block is for. */

  function findDrawer() {
    return ROOT.querySelector('cart-drawer') ||
           ROOT.querySelector('.cart-drawer') ||
           ROOT.querySelector('#CartDrawer') || null;
  }

  function sectionHost(el) {
    return el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
  }

  function cartSectionIds() {
    /* Shrine renders the drawer as a snippet, not a section, so there is no
       shopify-section wrapper to read an id off. Ask for the section files by
       name and add anything else the page happens to wrap. */
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    function push(el) {
      var host = sectionHost(el);
      if (!host) return;
      var id = host.id.replace(/^shopify-section-/, '');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    push(findDrawer());
    push(ROOT.querySelector('#cart-icon-bubble, .cart-count-bubble'));
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string' || !html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot = parsed.getElementById('shopify-section-' + id) || parsed.body;

        var host = ROOT.getElementById('shopify-section-' + id);
        if (host) { host.innerHTML = freshRoot.innerHTML; return; }

        var freshDrawer = freshRoot.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
        var liveDrawer = findDrawer();
        if (freshDrawer && liveDrawer) {
          liveDrawer.replaceWith(ROOT.importNode(freshDrawer, true));
          return;
        }

        var freshBubble = freshRoot.querySelector('#cart-icon-bubble, .cart-count-bubble');
        var liveBubble = ROOT.querySelector('#cart-icon-bubble, .cart-count-bubble');
        if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
      } catch (err) { /* leave the drawer as-is rather than blanking it */ }
    });
  }

  function syncCartCount() {
    if (!rawFetch) return;
    rawFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ROOT.querySelectorAll('[data-rvx-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-empty', cart.item_count > 0 ? 'false' : 'true');
        });
      })
      .catch(function () {});
  }

  var refreshLock = null;
  function refreshCart() {
    if (!rawFetch || refreshLock) return;
    refreshLock = window.setTimeout(function () { refreshLock = null; }, 300);
    syncCartCount();
    var ids = cartSectionIds();
    if (!ids.length) return;
    rawFetch('/?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applySections)
      .catch(function () {});
  }

  /* Any script on the page that touches the cart — a bundle app, a subscription
     widget, the theme itself — gets the drawer redrawn for free. */
  function watchCartRequests() {
    try {
      if (rawFetch) {
        window.fetch = function (input) {
          var url = '';
          try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (err) {}
          var p = rawFetch.apply(null, arguments);
          if (CART_RE.test(url)) {
            p.then(function (res) {
              if (res && res.ok && !ownAdd) refreshCart();
            }).catch(function () {});
          }
          return p;
        };
      }
    } catch (err) {}

    try {
      var xopen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try { this.__rvxUrl = String(url || ''); } catch (err) {}
        return xopen.apply(this, arguments);
      };
      var xsend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var self = this;
        try {
          this.addEventListener('load', function () {
            if (CART_RE.test(self.__rvxUrl || '') && self.status >= 200 && self.status < 300) refreshCart();
          });
        } catch (err) {}
        return xsend.apply(this, arguments);
      };
    } catch (err) {}
  }
  watchCartRequests();

  /* ---------- shared bits ---------- */
  function currentVariantId(btn) {
    var picker = ROOT.querySelector('[data-rvx-variant-picker]');
    if (picker && picker.value) return picker.value;
    var hidden = ROOT.querySelector('[data-rvx-variant-input]');
    if (hidden && hidden.value) return hidden.value;
    return btn ? btn.getAttribute('data-variant-id') : null;
  }

  function currentQty() {
    var q = ROOT.querySelector('[data-rvx-qty]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (!n || n < 1) ? 1 : n;
  }

  function openCart() {
    var drawer = findDrawer();
    if (window.theme && typeof window.theme.openCartDrawer === 'function') { window.theme.openCartDrawer(); return true; }
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    ROOT.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    ROOT.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    return !!drawer;
  }

  function afterAdd(data) {
    applySections(data && data.sections);
    syncCartCount();
    var opened = openCart();
    if (!opened) {
      setTimeout(function () {
        if (!ROOT.querySelector('.cart-drawer.is-open, cart-drawer[open], .drawer--is-open')) window.location.href = '/cart';
      }, 450);
    }
  }

  /* ---------- the buy form ----------
     Bundle and subscription apps do not ship a button. They inject hidden
     inputs into the /cart/add form and reuse its submit button. So we send the
     whole form, exactly as it stands at the moment of submit, and whatever the
     app wrote in there rides along. */
  ROOT.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-rvx-form]') : null;
    if (!form || e.defaultPrevented || !rawFetch) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.classList.contains('is-busy')) return;
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.classList.add('is-busy'); btn.innerHTML = 'Adding...'; }

    function restore() {
      if (!btn) return;
      btn.classList.remove('is-busy');
      btn.innerHTML = label;
    }

    var body = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }

    ownAdd = true;
    rawFetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function (data) { ownAdd = false; restore(); afterAdd(data); })
      .catch(function () { ownAdd = false; restore(); window.location.href = '/cart'; });
  });

  /* ---------- sticky bar button ---------- */
  function submitForm(form) {
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return true; }
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    return true;
  }

  ROOT.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rvx-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;

    /* The sticky bar sits outside the buy form. Hand the click to the form so
       whatever a bundle app has written into it is respected. */
    var form = ROOT.querySelector('[data-rvx-form]');
    if (form && !form.contains(btn)) { submitForm(form); return; }

    var id = currentVariantId(btn);
    if (!id || !rawFetch) { window.location.href = '/cart'; return; }

    var label = btn.innerHTML;
    btn.classList.add('is-busy');
    btn.innerHTML = 'Adding...';

    var payload = { items: [{ id: Number(id), quantity: currentQty() }] };
    var ids = cartSectionIds();
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }

    ownAdd = true;
    rawFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function (data) {
        ownAdd = false;
        btn.classList.remove('is-busy');
        btn.innerHTML = label;
        afterAdd(data);
      })
      .catch(function () {
        ownAdd = false;
        btn.classList.remove('is-busy');
        btn.innerHTML = label;
        window.location.href = '/cart';
      });
  });

  /* ---------- quantity stepper ---------- */
  ROOT.addEventListener('click', function (e) {
    var step = e.target.closest('[data-rvx-qty-step]');
    if (!step) return;
    e.preventDefault();
    var input = ROOT.querySelector('[data-rvx-qty]');
    if (!input) return;
    var dir = parseInt(step.getAttribute('data-rvx-qty-step'), 10) || 1;
    var next = (parseInt(input.value, 10) || 1) + dir;
    input.value = next < 1 ? 1 : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- desktop gallery thumbnails ---------- */
  ROOT.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-rvx-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-rvx-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-rvx-gallery-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset');
    main.alt = thumb.getAttribute('data-alt') || main.alt;
    gallery.querySelectorAll('[data-rvx-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---------- swipe rails: dots, no arrows ---------- */
  function initSlider(rail) {
    if (rail.__rvxDots) return;
    var kids = Array.prototype.slice.call(rail.children);
    if (kids.length < 2) return;
    rail.__rvxDots = true;

    var dots = ROOT.createElement('div');
    dots.className = 'rvx-dots';

    kids.forEach(function (kid, i) {
      var d = ROOT.createElement('button');
      d.type = 'button';
      d.className = 'rvx-dot';
      d.setAttribute('aria-label', 'Show item ' + (i + 1) + ' of ' + kids.length);
      d.addEventListener('click', function () {
        rail.scrollTo({ left: offsets()[i], behavior: 'smooth' });
      });
      dots.appendChild(d);
    });

    (rail.parentElement || rail).appendChild(dots);

    function offsets() {
      var base = kids[0].offsetLeft;
      return kids.map(function (k) { return k.offsetLeft - base; });
    }

    function sync() {
      var scrollable = rail.scrollWidth > rail.clientWidth + 4 && rail.clientWidth > 0;
      dots.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
      if (!scrollable) return;
      var offs = offsets();
      var pos = rail.scrollLeft + 8;
      var active = 0;
      for (var i = 0; i < offs.length; i++) { if (offs[i] <= pos) active = i; }
      if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4) active = offs.length - 1;
      var buttons = dots.querySelectorAll('.rvx-dot');
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].setAttribute('aria-current', j === active ? 'true' : 'false');
      }
    }

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
    window.setTimeout(sync, 400);
  }

  function initSliders() {
    ROOT.querySelectorAll('[data-rvx-slider]').forEach(initSlider);
  }

  /* ---------- header: slide-out menu ---------- */
  function initHeader() {
    var openers = ROOT.querySelectorAll('[data-rvx-menu-open]');
    if (!openers.length) return;

    function close() { ROOT.documentElement.classList.remove('rvx-menu-open'); }
    function open() { ROOT.documentElement.classList.add('rvx-menu-open'); }

    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    ROOT.querySelectorAll('[data-rvx-menu-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    ROOT.querySelectorAll('.rvx-drawer a').forEach(function (a) { a.addEventListener('click', close); });
    ROOT.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- sticky buy bar ---------- */
  function initBuybar() {
    var bar = ROOT.querySelector('[data-rvx-buybar]');
    if (!bar) return;
    var anchor = ROOT.querySelector('[data-rvx-hero]');
    if (!anchor || !('IntersectionObserver' in window)) { bar.setAttribute('data-hidden', 'false'); return; }
    bar.setAttribute('data-hidden', 'true');
    new IntersectionObserver(function (entries) {
      bar.setAttribute('data-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 }).observe(anchor);
  }

  function boot() { initSliders(); initHeader(); initBuybar(); syncCartCount(); }

  if (ROOT.readyState === 'loading') ROOT.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor re-renders a section — re-init what it contains */
  ROOT.addEventListener('shopify:section:load', boot);
})();